import { Box } from "@mui/material";
import { Organization } from "@sista/library-stasi";
import {
  OrganizationProjectList,
  ProjectList,
} from "@sista/service-project-skeleton";

export type OrganizationProjectsContentProps = {
  organization: Organization;
};

export const OrganizationProjectsContent = (
  props: OrganizationProjectsContentProps
) => {
  return (
    <Box sx={{ mt: 2 }}>
      <OrganizationProjectList
        filter={{
          organizationId: props.organization.id,
        }}
        displayColumns={[
          "projectCode",
          "projectTitleCz",
          "callForProposal",
          "projectState",
          "projectSubState",
          "projectMainApplicantId",
          "projectAdminId",
        ]}
      />
    </Box>
  );
};
